import VisionImage from "../../../assets/logo/DSC_5463-1024x693-1.webp";
export default function MissionValuesSection() {
  const values = [
    {
      icon: "ri-focus-3-line",
      title: "Precision",
      description:
        "Every line, dimension, and detail is crafted with meticulous accuracy to ensure flawless execution.",
    },
    {
      icon: "ri-lightbulb-line",
      title: "Innovation",
      description:
        "We embrace cutting-edge technology and methodologies to deliver forward-thinking design solutions.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Client-Focused",
      description:
        "Your success is our priority. We listen, adapt, and deliver solutions tailored to your specific needs.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Reliability",
      description:
        "Consistent quality, on-time delivery, and dependable service you can count on, project after project.",
    },
    {
      icon: "ri-team-line",
      title: "Collaboration",
      description:
        "We work seamlessly with your team, fostering open communication and shared project success.",
    },
  ];

  return (
    <section className="py-20 bg-[#dbcfbf]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <img
              src={VisionImage}
              alt="Team Collaboration"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-xl"
            />
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#e18033] rounded-2xl flex items-center justify-center shadow-xl">
              <div className="text-center text-white">
                <div className="text-2xl font-bold">21+</div>
                <div className="text-sm">Years</div>
              </div>
            </div>
          </div>

          {/* Mission & Values */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#212026] mb-6">
              Our Mission & Values
            </h2>

            <div className="mb-8 p-6 bg-white rounded-xl shadow-sm border border-[#dbcfbf]/30">
              <h3 className="text-xl font-bold text-[#212026] mb-3">
                Our Mission
              </h3>
              <p className="text-[#889d8f] leading-relaxed">
                At Drafting By DMI, our mission is to transform ideas into
                buildable, beautiful realities. We bridge engineering precision
                with creative visualization—delivering lighting, drafting, and
                rendering solutions that empower clients to design, approve, and
                construct with confidence.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-xl font-bold text-[#212026] mb-6">
                Our Core Values
              </h3>
              {values.map((value, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#e18033] rounded-lg flex items-center justify-center flex-shrink-0">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className={`${value.icon} text-white text-xl`}></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-[#212026] mb-2">
                      {value.title}
                    </h4>
                    <p className="text-[#889d8f] leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
